module.exports = __webpack_public_path__ + "media/Burruss Hall Part 4.0cdd42ea.mp3";